import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import UserList from './user_list';
import UserDetail from './user_detail';

class UserSetting extends Component {
    render() {
        return (
            <div>
                <Switch>
                    <Route path="/settings/users/:user_id" component={UserDetail}/>
                    <Route path="/settings/users" component={UserList}/>
                    <Redirect from="*" to= "/settings/users"/>
                </Switch>
            </div>
        );
    }
}

export default UserSetting;
